import React, { Component } from 'react'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs, Crumb } from 'components/BreadCrumbs'
import Button from 'components/Button'
import HeadingBanner from 'components/Text/HeadingBanner'
import BillingList from 'features/Billing/BillingList'

import cn from 'classnames'
import sMarg from 'styles/modules/margins.scss'
import sText from 'components/Text/Text.scss'

export default class BillingAccounts extends Component {
  render() {
    const { showBillingCreateFormModal } = this.props

    return (
      <Page layout={{ header: 'app' }} title="Billing Accounts">
        <PageHeader>
          <Crumbs title="Billing">
            <Crumb to="/dashboard/billing">Bills</Crumb>
            <Crumb to="/dashboard/billing/payments">Payments</Crumb>
            <Crumb active to="/dashboard/billing/accounts">
              Accounts
            </Crumb>
          </Crumbs>
          <HeadingBanner>
            <h3 className={cn(sText.heading3, sText.accent)}>
              Sometimes it’s easier to just divide and conquer
            </h3>
            <div className={sText.descrip2}>
              Create multiple billing accounts for your marketing requirements when you need them.
              It’s as easy as setting up a billing account for that campaign or client right here in
              the portal. You can also have an overview of all the active billing accounts.
            </div>
          </HeadingBanner>
        </PageHeader>
        <Container paddingTop paddingBottom className="sm">
          <Button
            className={sMarg.mb30}
            onClick={() => showBillingCreateFormModal()}
            color="tertiary"
          >
            Create Billing Account
          </Button>
          <BillingList />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/BillingAccounts/BillingAccounts.jsx